const cards = [
  {
    title: '某顶流男星私密视频流出：背后操作团队浮出水面',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20scene%20with%20warm%20golden%20spotlight%20and%20deep%20charcoal%20shadows%2C%20cinematic%20film%20noir%20aesthetic%2C%20mysterious%20luxury%20atmosphere%2C%20amber%20light%20rays%2C%20editorial%20photography%2C%20sophisticated%20dark%20mood&width=640&height=420&seq=card-cover-01&orientation=landscape',
    tag: '独家爆料',
    tagColor: 'accent',
    excerpt: '知情人士透露，该男星团队长期运作舆论控制，此次视频流出疑为内部矛盾爆发所致。',
    time: '3小时前',
    views: '128.6万',
  },
  {
    title: '网红圈假货产业链深度起底：从工厂到直播间',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20industrial%20scene%20with%20warm%20orange%20glow%2C%20cinematic%20documentary%20style%2C%20dark%20mysterious%20atmosphere%2C%20golden%20amber%20lighting%2C%20editorial%20composition%2C%20high%20contrast%2C%20sophisticated%20visual&width=640&height=420&seq=card-cover-02&orientation=landscape',
    tag: '深度调查',
    tagColor: 'primary',
    excerpt: '记者暗访南方某假货工厂，揭开网红直播带货背后完整的制假售假黑色产业链。',
    time: '5小时前',
    views: '96.3万',
  },
  {
    title: '知名女星离婚案最新进展：财产分割细节曝光',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20elegant%20dramatic%20scene%20with%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20split%20composition%2C%20mysterious%20luxury%20atmosphere%2C%20soft%20theatrical%20lighting%2C%20editorial%20photography%20style%2C%20sophisticated%20mood&width=640&height=420&seq=card-cover-03&orientation=landscape',
    tag: '追踪报道',
    tagColor: 'secondary',
    excerpt: '双方律师已进行多轮谈判，涉及房产、股权及品牌代言等巨额财产的分割方案。',
    time: '8小时前',
    views: '74.5万',
  },
  {
    title: '综艺导演被实名举报：利用职务之便索贿受贿',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20warm%20spotlight%20and%20dark%20shadows%2C%20film%20noir%20aesthetic%2C%20mysterious%20theatrical%20atmosphere%2C%20golden%20amber%20contrast%2C%20editorial%20documentary%20style%2C%20sophisticated%20composition&width=640&height=420&seq=card-cover-04&orientation=landscape',
    tag: '重磅实锤',
    tagColor: 'accent',
    excerpt: '多位参赛选手联合举报某知名综艺导演，举报材料中附有转账记录和聊天截图。',
    time: '12小时前',
    views: '68.2万',
  },
  {
    title: '娱乐圈新生代小生学历造假风波持续升级',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20academic%20theme%20with%20warm%20amber%20lighting%2C%20cinematic%20mysterious%20atmosphere%2C%20dark%20shadows%20and%20golden%20highlights%2C%20editorial%20photography%20style%2C%20sophisticated%20intellectual%20mood%2C%20high%20contrast&width=640&height=420&seq=card-cover-05&orientation=landscape',
    tag: '持续追踪',
    tagColor: 'primary',
    excerpt: '网友深扒发现其学历证书有多处疑点，母校回应引发更大争议，代言品牌紧急评估。',
    time: '1天前',
    views: '52.4万',
  },
];

const tagColorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700',
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-newspaper-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选爆料</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">编辑精选 · 黑料在线不容错过的深度爆料内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card) => (
            <a
              key={card.title}
              href="#media"
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-background-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.cover}
                  alt={`${card.title} - 黑料在线精选爆料`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColorMap[card.tagColor]}`}>{card.tag}</span>
                  <span className="text-xs text-foreground-500">{card.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">{card.excerpt}</p>
                <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
          {cards.slice(3).map((card) => (
            <a
              key={card.title}
              href="#media"
              className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-background-300 transition-colors cursor-pointer"
            >
              <div className="w-full sm:w-48 flex-shrink-0 aspect-[3/2] sm:aspect-auto rounded-md overflow-hidden bg-background-200">
                <img
                  src={card.cover}
                  alt={`${card.title} - 黑料在线精选爆料`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColorMap[card.tagColor]}`}>{card.tag}</span>
                    <span className="text-xs text-foreground-500">{card.time}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{card.excerpt}</p>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-foreground-500 mt-2">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}